import { copyText } from "@/lib/copy";
import { Copy, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SecretDialog = ({ secret, onClose }) => {
  const copy = () => copyText(secret);
  return (
    <Dialog open={!!secret} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="secret-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#C2410C]" /> Votre nouvelle clé</DialogTitle>
          <DialogDescription>Copiez-la maintenant et transmettez-la à votre partenaire : elle ne sera plus jamais affichée.</DialogDescription>
        </DialogHeader>
        <code onClick={copy} title="Cliquer pour copier" className="block cursor-copy break-all rounded-md bg-stone-900 text-amber-200 p-4 text-sm font-mono select-all" data-testid="secret-value">{secret}</code>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={copy} data-testid="secret-copy-button"><Copy className="h-4 w-4 mr-1.5" /> Copier</Button>
          <Button className="bg-[#C2410C] hover:bg-[#9A3412] text-white" onClick={onClose} data-testid="secret-close-button">J'ai copié la clé</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
